/*
 * (c)任务模块请求特殊处理
 *
 */
import { BROWSER_TYPE, AUTH_TOKEN_REFRESH } from "libs/conf";

export function isInTaskPage() {
  return window?.location.pathname.includes("/activity/task");
}
// app 调用window上的 refreshTaskList 涉及到的接口
const TASK_PAGE_REQUEST_URLS = [
  "/api/todo/myToDo",
  "/api/todo/listFinish",
  "/api/todo/listEggMission",
  "/api/app/user/getUserInfo",
  "/api/todo/getMissionUnifiedConfig",
];

export function isTaskRequest(url: string): boolean {
  if (isInTaskPage() && BROWSER_TYPE.App) {
    if (url.startsWith("http")) {
      const { pathname } = new URL(url);
      return TASK_PAGE_REQUEST_URLS.includes(pathname);
    }
    const [pathname] = url.split("?");
    return TASK_PAGE_REQUEST_URLS.includes(pathname);
  }
  return false;
}

//
export function getTokenFromStorage(): string {
  let token = "";
  if (BROWSER_TYPE.App) {
    return window?.localStorage.getItem(AUTH_TOKEN_REFRESH);
  }
  return token;
}

export function clearRefreshToken(): void {
  if (window?.localStorage) {
    window.localStorage?.removeItem(AUTH_TOKEN_REFRESH);
  }
}

export function clearOwnerGuideStorage(): void {
  if (window?.sessionStorage) {
    window.sessionStorage?.removeItem("appId");
    window.sessionStorage?.removeItem("carSeries");
    window.sessionStorage?.removeItem("editionName");
    window.sessionStorage?.removeItem("selectTitle");
    window.sessionStorage?.removeItem("vin");
  }
}
